import { MultigameParams } from "../../MultigameParams";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SlotGameInitData } from "../../SlotGameInitData";
import { ChangeSpeedParams, SlotGameType1 } from "../SlotGameType1";
// import { ImageResource } from "../../ResourceManager/ImageResource";
// import { Sprite } from "../Sprite/Sprite";
// import { SpriteResource } from "../../ResourceManager/SpriteResource";
// import { CanvasSprite } from "../Sprite/CanvasSprite";
import { Help, HelpParameters, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { FreegamePickElement } from "../FreegameBonus/FreegamePickElement";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { ButtonColors, Panel } from "../panel/panel";
import { PickBonus, PickBonusFactory } from "../PickBonus/PickBonus";
import { PickBonusElement } from "../PickBonus/PickBonusElement";
import { PickBonusParams, PickBonusPickElementParams } from "../PickBonus/PickBonusParams";
// namespace SlotGames
// namespace SlotGames
// {
	export class SecretsOfAnubis extends SlotGameType1 
	{
		// override default factory with one that creates custom anubis freegame
		//protected override freegameBonusFactory: FreegameBonusFactory = new SecretsOfAnubisFreegameBonusFactory();
		protected override pickBonusFactory:PickBonusFactory = new SecretsOfAnubisPickBonusFactory();
		
		//protected panelFactory:IPanelFactory = new SecretsOfAnubisPanelFactory();
		protected override helpFactory:IHelpFactory = new SecretsOfAnubisHelpFactory();
	
		//LED COLOR
		protected override ColorLed:string="205,164,52\n";

		constructor(multigameParams: MultigameParams, initData: SlotGameInitData) 
		{
			super(multigameParams, initData, "SecretsOfAnubis");

			this.spinnableReelsParams.topBorderWidth = 6;
			this.spinnableReelsParams.bottomBorderWidth = 6;
		}

        public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
		{
           await super.ResourcesLoaded(loadingStage, resourceManager);

            if (loadingStage != LoadingStage.Games) {
                return;
            }

			this.winLinesAnimation.AddStartLineCallback(() => {this.audio.Play(this.resid.ScopedResourceName("win")); this.audio.PlayLoop(this.resid.ScopedResourceName("win")); });
			this.winLinesAnimation.AddCompleteCallbacks(() => {this.audio.Stop(this.resid.ScopedResourceName("win")); /*this.audio.Play(this.resid.ScopedResourceName("linecountend"));*/ });
		}

	}

	/***************************************************************************
	 *	ANUBIS FREEGAME BONUS
	 **************************************************************************/

	

	// class AnubisFreegameBonus extends FreegameBonus 
	// {
	// 	public constructor(gameName: string, params: FreegameBonusParams ) {
	// 		super(gameName, params);
	// 		this.spinnableReelsParams.topBorderWidth = 6;
	// 		this.spinnableReelsParams.bottomBorderWidth = 6;
	// 	}

	// 	public override OnPicked(index: number): void {
	// 		//super.OnPicked(index);

	// 		if (this.stateMachine.State() == FreegameStates.Pick)
	// 		{
	// 			// Log.Debug(this.logGroup, "Picked index " + index);
	
	// 			// TODO check state, check index bounds
	// 			this.pickedIndex = index;
	// 			// protocol.Send("SelectBonusElement",{selectedElement: index});
	
	// 			for (let i = 0; i < this.picks.length; i++) {
	// 				if (i == index) {
	// 					this.picks[i].BringToFront();
	// 					this.picks[i].awardElem.style.fontSize = "90px";
	// 					this.picks[i].awardElem.style.left = "80px";
	// 					this.picks[i].awardElem.style.top = "20px";
	// 				}
	// 				else {
	// 					this.picks[i].PushToBack();
	// 				}
	// 			}
	
	// 			this.stateMachine.ChangeState(FreegameStates.RevealPicked);
	// 		}
	// 	}



		

	// 	// set new pick positions
	// 	protected override PicksPositions(): FreegamePickElemGeometry[] {
	// 		let geometry: FreegamePickElemGeometry[] = [];

	// 		let displayWidth: number = 540 * 0.75;
	// 		let displayHeight: number = 510 * 0.75;

	// 		let displayRects: PixelRect[] = [
	// 			new PixelRect(29, 678, displayWidth, displayHeight),
	// 			new PixelRect(448, 612, displayWidth, displayHeight),
	// 			new PixelRect(791, 614, displayWidth, displayHeight),
	// 			new PixelRect(1112, 707, displayWidth, displayHeight),
	// 			new PixelRect(1487, 740, displayWidth, displayHeight),
	// 		];

	// 		// offset relative to pick rect
	// 		let pickRect = new PixelRect(50, 35, displayWidth - 100, displayHeight - 100);

	// 		for (let i = 0; i < displayRects.length; i++) {
	// 			geometry.push(new FreegamePickElemGeometry(displayRects[i], pickRect));
	// 		}

	// 		return geometry;
	// 	}


	// 	// protected PrepareMessage(resourceManager: ResourceManager)
	// 	// {
	// 	// 	super.PrepareMessage(resourceManager);

	// 	// 	//override dialog box message color
	// 	// 	this.pickIntroMessageContainer.style.color = "#ffe548";

	// 	// 	SetStyles(this.view.querySelectorAll(".dialogContainer"),{
	// 	// 		textShadow:"4px 5px black"
	// 	// 	})
	// 	// 	SetStyles(this.view.querySelectorAll(".header"),
	// 	// 	{
	// 	// 		fontSize:"70px"

	// 	// 	});
	// 	// 	SetStyles(this.view.querySelectorAll(".bonusName"),{
	// 	// 		fontSize:"70px"
	// 	// 	});

	// 	// 	SetStyles(this.view.querySelectorAll(".contents2"),{
	// 	// 		fontSize:"40px",
	// 	// 		bottom: "230px"
	// 	// 	});
	// 	// 	SetStyles(this.view.querySelectorAll(".startbut"),{
	// 	// 		fontSize:"70px"
	// 	// 	});
	// 	// 	SetStyles(this.view.querySelectorAll("#startfree3"),{fontSize:"40px", bottom:"230px"});
	// 	// 	SetStyles(this.view.querySelectorAll("#startend3"),{fontSize:"36px", bottom:"230px"});
	// 	// }
	// }
	
	//Panel Colorized
	class SecretsOfAnubisPanelFactory implements IPanelFactory
	{
		public CreateNewPanel(params: PanelParams):Panel
		{
			return new SecretsOfAnubisPanel(params);
		}
	}

	class SecretsOfAnubisPanel extends Panel
	{
		protected override ButtonBackground():ButtonColors
		{
			let color:ButtonColors ={
				backgroundButtonColor: "linear-gradient(rgb(38, 13, 4),rgb(64, 30, 10), rgb(112, 55, 22),rgb(64, 30, 10),rgb(38, 13, 4)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
				linearColor:"linear-gradient(to left , transparent, rgb(191, 83, 21),transparent ) 0 10 100%",
			};
			
			return color;
		}
	}

	
//Help Colorized
class SecretsOfAnubisHelpFactory implements IHelpFactory
{
	public CreateNewHelp(params: HelpParameters):Help
	{
		return new  SecretsOfAnubisHelp(params);
	}
}

class SecretsOfAnubisHelp extends Help
{
	protected override BackgroundPanel():HelpPanelColor
	{
		let color:HelpPanelColor = {
			backgroundPanelColor:  "linear-gradient(rgb(64, 10, 5),rgb(89, 23, 8), rgb(140, 52, 20),rgb(89, 23, 8),rgb(64, 10, 5)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		};

		return color;
	}
}
	
	/**
	 * PICK BONUS
	 */
	class SecretsOfAnubisPickBonus extends PickBonus
	{
		public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
			throw new Error("Method not implemented.");
		}
		
	}

	class SecretsOfAnubisPickBonusElement extends PickBonusElement
	{
		
	}
	
	class SecretsOfAnubisFreegamePickElement extends FreegamePickElement
	{
	}



	// class SecretsOfAnubisFreegameBonusFactory extends FreegameBonusFactory
	// {
	// 	public override CreateFreegameBonus(gameName: string, params: FreegameBonusParams): FreegameBonus
	// 	{
	// 		return new AnubisFreegameBonus(gameName, params);
	// 	}

	// 	public override CreatePickElement(params: FreegamePickElementParams): FreegamePickElement
	// 	{
	// 		return new SecretsOfAnubisFreegamePickElement(params);
	// 	}
	// }


	class SecretsOfAnubisPickBonusFactory extends PickBonusFactory
	{
		public override CreatePickBonus(gameName: string, params: PickBonusParams): PickBonus
		{
			return new SecretsOfAnubisPickBonus(gameName, params);
		}

		public override CreatePickElement(params: PickBonusPickElementParams): PickBonusElement
		{
			return new SecretsOfAnubisPickBonusElement(params);
		}
		
	}
// }



